import { render, staticRenderFns } from "./translationsMenu.vue?vue&type=template&id=985e62f2&"
import script from "./translationsMenu.vue?vue&type=script&lang=js&"
export * from "./translationsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports